import styled from 'styled-components'

export const Container = styled.article`
  align-items: flex-start;
  color: #fff;
  display: flex;
  /* display: none; */
  min-height: 45rem;
  justify-content: space-between;
  flex-wrap: wrap;
  text-align: center;
  width: 90%;

  section {
    min-height: 35rem;
  }

  div {
    cursor: pointer;
    align-items: center;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    justify-content: center;
    height: 7rem;
    width: 6rem;
    margin: 5px;
    margin-bottom: 10px;
    border: #fff 1px solid;
    /* background-color: antiquewhite; */
  }

  img {
    margin-top: 10px;
    width: 40px;
  }

  @media only screen and (min-width: 1000px) {
    margin-top: 50px;
  }
`
